export interface CertificateTemplate {
  id: string;
  nameKey: string;
  certs: string[];
}

export const PREDEFINED_TEMPLATES: CertificateTemplate[] = [
  {
    id: 'standard',
    nameKey: 'certificateOverview.templates.standard',
    certs: ['ctfl', 'ctAi', 'ctGenAi', 'ctalTm', 'ctalTa', 'ctalTae', 'cprefl', 'ctflAt', 'ctFt', 'a4qAiEssentials'],
  },
  {
    id: 'basis',
    nameKey: 'certificateOverview.templates.basis',
    certs: ['ctfl', 'a4qAiEssentials'],
  },
  {
    id: 'ki',
    nameKey: 'certificateOverview.templates.ki',
    certs: ['ctAi', 'ctGenAi'],
  },
  {
    id: 'aiLiteracy',
    nameKey: 'certificateOverview.templates.aiLiteracy',
    certs: ['ctfl', 'a4qAiEssentials', 'ctGenAi', 'ctAi'],
  },
  {
    id: 'istqb',
    nameKey: 'certificateOverview.templates.istqb',
    certs: ['ctfl', 'ctAi', 'ctGenAi', 'ctalTm', 'ctalTa', 'ctalTae', 'ctflAt', 'ctAct', 'ctPt', 'ctFt', 'ctMat', 'ctMbt', 'ctSec', 'ctal', 'ctalTta', 'ctflAut'],
  },
];
